// src/components/Guards/GuardAuth.jsx
import React from "react";
import Login from "../Layout/Login/Login";
import { useAuthentication } from "../../Hooks/useAuthentication";
import AccessDenied from "./AccessDenied";

const AuthGuard = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, role } = useAuthentication();

  // Si no está autenticado, mostrar login
  if (!isAuthenticated) {
    return <Login />;
  }

  // Si hay roles permitidos y el rol del usuario no está en la lista, denegar acceso
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return (
      <AccessDenied />
    );
  }

  // Usuario autenticado y con rol permitido
  return children;
};

export default AuthGuard;
